export default "__VITE_ASSET__c50c64eb__"